import { Header } from './components/Header/';
import { Section } from './components/Section';
import './App.css';

function App() {
  return (
    <>
        <Header />
        <Section />
    </>
  );
}

export default App;
